<template>
  <div class="opportunity map" :class="{ sticky }" style="height: 100%; max-height: 90vh;">
    <LeaplyMap
      v-bind="{ ...$attrs, ...$props, useQueryParams: true, spreadMarkers: true }"
      @update:bounds="$emit('update:bounds', $event)"
      @update:center="$emit('update:center', $event)"
    >
      <OpportunityMapMarker
        slot="marker"
        slot-scope="location"
        :key="`opportunity-map-marker-${location.id}`"
        :marker="location"
        @apply="$emit('apply', $event)"
      />
      <OpportunityMapLegend slot="legend" />
    </LeaplyMap>
  </div>
</template>

<script>
// Components
import LeaplyMap from '@/components/maps/LeaplyMap'
import OpportunityMapLegend from '@/components/maps/OpportunityMapLegend'
import OpportunityMapMarker from '@/components/maps/OpportunityMapMarker'

export default {
  name: 'OpportunityMap',

  // So $attrs can be passed to Leaply map
  inheritAttrs: false,

  components: { LeaplyMap, OpportunityMapLegend, OpportunityMapMarker },

  props: {
    loading: { type: Boolean, default: false },
    markers: { type: Array, default: () => [] },
    sticky: { type: Boolean, default: false },
  },

  computed: {
    geoLocation() {
      return this.$store.getters['geolocation/location']
    },
  },

  watch: {
    geoLocation: function(newLocation, oldLocation) {
      if (oldLocation && (oldLocation.latitude || oldLocation.longitude)) return

      if (this.geoLocation && this.geoLocation.latitude && this.geoLocation.longitude) {
        this.center = [this.geoLocation.latitude, this.geoLocation.longitude]
      }
    },
  },
}
</script>

<style lang="scss">
.opportunity.map {
  position: relative;

  &.sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}
</style>
